import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "visually-hidden" }
const _hoisted_2 = {
  class: "HomeTicker_Track",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "HomeTicker_Text" }
const _hoisted_4 = ["src"]

import translations from '@/dictionaries/homepage.json';
import starIconUrl from '@/assets/img/icon-etoile-blanc.svg';

// Repetitions per group: enough for one group to stay wider than very large screens
const REPEAT = 8;


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeTickerComponent',
  setup(__props) {

const text = translations.ticker.fr.text;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "HomeTicker",
    style: _normalizeStyle({ '--ticker-repeat': REPEAT })
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(text)), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (group) => {
        return _createElementVNode("div", {
          key: group,
          class: "HomeTicker_Group"
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(REPEAT, (item) => {
            return _createElementVNode("span", {
              key: item,
              class: "HomeTicker_Item"
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(text)), 1),
              _createElementVNode("img", {
                class: "HomeTicker_Star",
                src: _unref(starIconUrl),
                alt: "",
                width: "15",
                height: "14"
              }, null, 8, _hoisted_4)
            ])
          }), 64))
        ])
      }), 64))
    ])
  ], 4))
}
}

})